import '../vendor/fslightbox.min.js';

var lightbox = {};

lightbox.init = function() {
	for (let name in fsLightboxInstances) {
		fsLightboxInstances[name].element.addEventListener('open', function (e) {
			e.preventDefault();
			$('.fslightbox-container').addClass('fslightbox-fade-in-complete');
		});
		fsLightboxInstances[name].element.addEventListener('init', function (e) {
			e.preventDefault();
			$('.fslightbox-container').addClass('fslightbox-fade-in-complete');
		});
	}
}

document.querySelectorAll('.js-open-lightbox').forEach(function (element) {
	element.addEventListener('click', function (e) {
		e.preventDefault();
		openLightbox();
	});
});

function openLightbox() {
	let lightbox = document.querySelector('[data-custom-fslightbox]').getAttribute('data-custom-fslightbox');
	fsLightboxInstances[lightbox].open(0);
}

export { lightbox };
